import ImageIcon from "../../../../assets/icons/imageIcon";
import { TbEyeQuestion } from "react-icons/tb";
import { Tooltip } from "antd";
import styles from "./style.module.scss";

interface ReviewCountersProps {
  counters?: { total: number; forReview?: number };
}
export default function ReviewCounters({ counters }: ReviewCountersProps) {
  const displayForReview = !!counters?.forReview && counters?.forReview > 0;
  return (
    <div className={styles.counters}>
      <Tooltip title="Images in this label for the current round">
        <div className={styles.counter}>
          <div className={styles.counterIcon}>
            <ImageIcon />
          </div>
          <div>{`${counters?.total} images`}</div>
        </div>
      </Tooltip>
      {displayForReview && (
        <Tooltip title="Images still waiting for your review">
          <div className={styles.counter}>
            <div className={styles.counterIcon}>
              <TbEyeQuestion />
            </div>
            <div>{`${counters.forReview} For review`}</div>
          </div>
        </Tooltip>
      )}
    </div>
  );
}
